export default __webpack_public_path__ + "static/media/1813.72e5f244.png";